import { writable } from 'svelte/store'
import { Scene } from 'three'

export const storeScene = writable<Scene | null>(null)
export const setStoreScene = (value: Scene | null) =>
  storeScene.set(value)

export const storeSceneInvalidate = writable<() => void>()
export const setStoreSceneInvalidate = (value: () => void) =>
  storeSceneInvalidate.set(value)
